import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { postBalance } from '../../../../crud/users.crud';
import { getResponseMessage } from '../../../../utils/utils';
import { useFormatMessage } from '../../../../hooks';

export const useAddBalance = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const fm = useFormatMessage();

  const fetchBalance = async (user_id: number, amount: number) => {
    setLoading(true);
    postBalance(user_id, amount)
      .then(() => {
        setSuccess(true);
        enqueueSnackbar(fm('ADD.BALANCE.SUCCESS'), { variant: 'success' });
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`, { variant: 'error' });
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setSuccess(false);
        }, 100);
      });
  };

  return { fetchBalance, loading, success };
};
